import { Modal } from 'antd';
import styled from 'styled-components';
import { STATUS_BADGE_CONFIG, TAssetStatus } from './constant';

export const DetailWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  .detail_header {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    button.detail_back-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      background: #edeff1;
      border: none;
      border-radius: 8px;
      height: 40px;
      padding: 0 16px;
      cursor: pointer;
      font-size: var(--font-size-base);
      font-weight: var(--font-medium);
      color: var(--color-text-primary, #111827);
      transition: background 0.2s;
      position: relative;
      z-index: 1;

      &:hover {
        background: #dde1e5;
      }
    }

    h1 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      white-space: nowrap;
      font-weight: var(--font-bold);
      line-height: 46px;
      margin: 0;
    }
  }

  .detail_section {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 20px;

    .detail_section-title {
      font-size: var(--font-size-sm);
      font-weight: var(--font-medium);
      color: var(--color-text-secondary, #6b7280);
      margin-bottom: 16px;
      padding-bottom: 8px;
      border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    }
  }

  .detail_readonly-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 32px;
  }

  .detail_readonly-item {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .detail_readonly-label {
      font-size: var(--font-size-sm);
      color: var(--color-text-secondary, #6b7280);
      font-weight: var(--font-medium);
    }

    .detail_readonly-value {
      background: #f3f4f6;
      border: 1px solid var(--color-border-primary, #e5e7eb);
      border-radius: 6px;
      padding: 10px 14px;
      font-size: var(--font-size-base);
      font-weight: var(--font-medium);
      color: var(--color-text-primary, #111827);
      min-height: 42px;
      display: flex;
      align-items: center;

      &.is-empty {
        color: var(--color-text-secondary, #9ca3af);
      }

      &.is-link {
        color: var(--color-link, #1677ff);
        cursor: pointer;
        background: #f3f4f6;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .detail_form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 32px;

    .detail_form-full {
      grid-column: 1 / -1;
    }
  }

  .detail_status-row {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .detail_status-item {
    display: flex;
    align-items: center;
    gap: 16px;

    .detail_status-label {
      font-size: var(--font-size-base);
      font-weight: var(--font-medium);
      min-width: 160px;
      color: var(--color-text-primary, #111827);
    }
  }

  .detail_status-note {
    font-size: var(--font-size-sm);
    color: var(--color-text-secondary, #6b7280);
    margin-top: 2px;
  }

  .detail_status-radio-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .detail_footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 8px;

    .ant-btn {
      height: 48px;
      min-width: 120px;
      font-weight: var(--font-bold);
      border-radius: 8px;
    }

    .ant-btn-default {
      color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }

    .ant-btn-primary {
      background-color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }
  }

  .detail_validation-error {
    color: #ef4444;
    font-size: var(--font-size-sm);
    margin-top: 4px;
  }

  .ant-form-item {
    margin-bottom: 0;

    .ant-form-item-label label {
      font-weight: var(--font-medium);
    }

    .ant-input,
    .ant-select-selector,
    .ant-input-affix-wrapper {
      border-radius: 6px;
    }
  }
`;

export const StatusBadge = styled.span<{ status: TAssetStatus }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-medium);
  color: ${({ status }) => STATUS_BADGE_CONFIG[status].color};
  background: ${({ status }) => STATUS_BADGE_CONFIG[status].bg};
`;

export const SaveConfirmModalWrapper = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 12px;
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.12);
  }

  .ant-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    margin-bottom: 0;

    .ant-modal-title {
      font-weight: var(--font-bold);
      font-size: var(--font-size-base);
    }
  }

  .ant-modal-body {
    padding: 20px 24px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 24px 20px;
    margin-top: 0;
    border-top: 1px solid var(--color-border-primary, #e5e7eb);

    .ant-btn {
      min-width: 120px;
      height: 44px;
      font-weight: var(--font-bold);
      border-radius: 8px;
      margin-inline-start: 0 !important;
    }

    .ant-btn-default {
      color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }
  }

  .save-confirm_message {
    margin-bottom: 16px;
    font-size: var(--font-size-base);
    color: var(--color-text-primary, #111827);
  }

  .save-confirm_no-changes {
    color: var(--color-text-secondary, #6b7280);
    font-style: italic;
    text-align: center;
    padding: 16px 0;
  }

  .ant-table-wrapper {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    overflow: hidden;
  }
`;
